import React, { useEffect, useState } from "react";
import AddImage from "../../../../assets/icons/add-image.svg";
import { EditOutlined } from "@mui/icons-material";
import "../../../../assets/styles/variables.scss";
import ImageUpload from "../upload-image";
import TickMark from "../../../../assets/icons/tickMark.svg";
import CrossMark from "../../../../assets/icons/crossIcon.svg";
import LearnMoreButton from "./LearnMore";

interface CoreValuesProps {
  isForSharing: boolean;
  updateTitle?: any;
  title?: string;
  valuesPrinciplesData?: any;
  setValuesPrinciplesData?: any;
  sectionVisibility?: any;
  setSectionVisibility?: any;
  primaryColor?: string;
  accentColor?: string;
  setImageFiles?: any;
  canWrite?: boolean;
  canDelete?: boolean;
  previousValuesPrinciplesData?: any;
  setPreviousValuesPrinciplesData?: any;
}

const CoreValuesAndPrinciples: React.FC<CoreValuesProps> = ({
  isForSharing,
  valuesPrinciplesData,
  setValuesPrinciplesData,
  setSectionVisibility,
  sectionVisibility,
  primaryColor,
  accentColor,
  setImageFiles,
  canWrite = false,
  canDelete = false,
  previousValuesPrinciplesData,
  setPreviousValuesPrinciplesData,
}) => {
  const [editHeading, setEditHeading] = useState(false);
  const [editBody, setEditBody] = useState(false);

  const handleImageChange = (file: any) => {
    setImageFiles((prev: any) => ({
      ...prev,
      "values-principles": file,
    }));
    setValuesPrinciplesData((prev: any) => ({
      ...prev,
      imageUrl: file ? URL.createObjectURL(file) : "",
    }));
  };

  const handleImageRemove = () => {
    setValuesPrinciplesData((prev: any) => ({
      ...prev,
      imageUrl: "",
    }));
    setImageFiles((prev: any) => {
      const { ["values-principles"]: _, ...rest } = prev;
      return rest;
    });
  };

  const textColor = "#212529";

  return (
    <div>
      <div
        id="what-we-offer-wrapper"
        style={{
          padding: "20px 60px",
          backgroundColor: "white",
          color: textColor,
          position: "relative",
        }}
      >
        {!isForSharing && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "45px",
            }}
            className={
              sectionVisibility?.["partner-success-metrics"] && !isForSharing
                ? "section-header"
                : ""
            }
          >
            {sectionVisibility["values-principles"] && (
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  border: "none",
                  background: "transparent",
                  margin: 0,
                  wordBreak: "break-word",
                }}
              >
                {valuesPrinciplesData?.title || "What We Offer"}
              </h3>
            )}
            <button
              onClick={() => {
                if (setSectionVisibility) {
                  setSectionVisibility((prev: any) => ({
                    ...prev,
                    "values-principles": !prev["values-principles"],
                  }));
                }
              }}
              className={
                sectionVisibility?.["partner-success-metrics"]
                  ? "toggle-section-button"
                  : ""
              }
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                backgroundColor: "#fff",
                color: canWrite ? "#000000" : "rgba(0, 0, 0, 0.3)",
                boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                padding: "6px 24px",
                border: "none",
                cursor: "pointer",
                width: "147px",
                height: "42px",
                borderRadius: "8px",
                fontSize: "15px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              {sectionVisibility?.["values-principles"]
                ? "Show Section"
                : "Hide Section"}
            </button>
          </div>
        )}

        {!sectionVisibility?.["values-principles"] && (
          <div
            id="values-and-principles-body-wrapper"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              gap: "40px",
              height: !isForSharing ? "500px" : "auto",
              alignItems: "center",
            }}
          >
            <div
              style={{ display: "flex", width: "40%", flexDirection: "column" }}
              className="values-and-principles-body-wrapper-section"
            >
              {editHeading && !isForSharing ? (
                <input
                  type="text"
                  value={valuesPrinciplesData?.title || ""}
                  onChange={(e) => {
                    setValuesPrinciplesData((prev: any) => ({
                      ...prev,
                      title: e.target.value,
                    }));
                  }}
                  onBlur={() => setEditHeading(false)}
                  autoFocus
                  style={{
                    fontSize: "30px",
                    color: textColor,
                    backgroundColor: "transparent",
                    border: "none",
                    // borderBottom: `1px solid ${accentColor}`,
                    fontWeight: "500",
                    letterSpacing: "-0.05px",
                    outline: "none",
                    fontFamily: "Roboto, sans-serif",
                  }}
                  maxLength={40}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // width: "500px",
                    gap: 8,
                  }}
                >
                  <h3
                    style={{
                      fontSize: "30px",
                      margin: 0,
                      fontWeight: "500",
                      letterSpacing: "-0.02rem",
                      width: "auto",
                      maxWidth: "500px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      cursor: "default",
                    }}
                    title={valuesPrinciplesData?.title}
                  >
                    {valuesPrinciplesData?.title}
                  </h3>
                  {!isForSharing && (
                    <button
                      onClick={() => setEditHeading(true)}
                      style={{
                        background: "#fff",
                        border: "1px solid #ccc",
                        cursor: canWrite ? "pointer" : "not-allowed",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "50%",
                        padding: "4px",
                        width: "32px",
                        height: "32px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                      disabled={!canWrite}
                    >
                      <EditOutlined />
                    </button>
                  )}
                </div>
              )}
              {editBody && !isForSharing ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "600px",
                  }}
                >
                  <textarea
                    id="what-we-offer-body-text"
                    value={valuesPrinciplesData?.principles}
                    onChange={(e) => {
                      setValuesPrinciplesData((prev: any) => ({
                        ...prev,
                        principles: e.target.value,
                      }));
                    }}
                    onBlur={() => setEditBody(false)}
                    autoFocus
                    style={{
                      fontSize: "16px",
                      color: textColor,
                      backgroundColor: "transparent",
                      border: "1px solid #AAAAAA",
                      borderRadius: "4px",
                      textAlign: "left",
                      height: "200px",
                      marginTop: "30px",
                      padding: "10px 0px",
                      width: "100%",
                      boxSizing: "border-box",
                      outline: "none",
                      cursor: canWrite || isForSharing ? "text" : "not-allowed",
                    }}
                    disabled={isForSharing || !canWrite}
                    maxLength={300}
                  />

                  {/* Icons at bottom right */}
                  {!isForSharing && canWrite && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        right: "10px",
                        display: "flex",
                        gap: "8px",
                      }}
                    >
                      <img
                        src={CrossMark}
                        alt="Clear"
                        onClick={() => {
                          setValuesPrinciplesData((prev: any) => ({
                            ...prev,
                            principles:
                              previousValuesPrinciplesData?.principles || "",
                          }));
                        }}
                        style={{
                          cursor: "pointer",
                          width: "35px",
                          height: "35px",
                        }}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 8,
                  }}
                >
                  <p
                    style={{
                      letterSpacing: "-0.02rem",
                      width: "auto",
                      maxWidth: "750px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      cursor: "default",
                      fontSize: "18px",
                      lineHeight: "30px",
                      marginTop: "1rem",
                    }}
                  >
                    {valuesPrinciplesData?.principles || "Body Text..."}
                  </p>
                  {!isForSharing && (
                    <button
                      onClick={() => setEditBody(true)}
                      style={{
                        background: "#fff",
                        border: "1px solid #ccc",
                        cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "50%",
                        padding: "4px",
                      }}
                      disabled={!canWrite}
                    >
                      <EditOutlined fontSize="small" />
                    </button>
                  )}
                </div>
              )}
              <div
                className="learn-more-button-wrapper"
                style={{
                  justifyContent: "flex-start",
                  marginTop: "1rem",
                  display: "flex",
                }}
              >
                {!(isForSharing && !valuesPrinciplesData?.btnUrl?.trim()) && (
                  <LearnMoreButton
                    isForSharing={isForSharing}
                    primaryColor={accentColor}
                    link={valuesPrinciplesData?.btnUrl}
                    setLink={setValuesPrinciplesData}
                    canWrite={canWrite}
                  />
                )}
              </div>
            </div>
            {}
            <div
              style={{ width: "50%" }}
              className="values-and-principles-body-wrapper-section"
            >
              <ImageUpload
                imageUrl={valuesPrinciplesData?.imageUrl}
                onImageChange={handleImageChange}
                onImageRemove={handleImageRemove}
                isForSharing={isForSharing}
                placeholderImage={AddImage}
                sectionName="values-principles"
                canWrite={canWrite}
                canDelete={canDelete}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CoreValuesAndPrinciples;
